import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="text-lg font-bold font-heading text-background-50 mb-4">
                2pg<span className="text-primary-400">·</span>com
              </h3>
              <p className="text-sm text-background-400 leading-relaxed">
                简单快捷的在线游戏娱乐平台，手机/邮箱一键注册，安全加密保障，立即开户畅享海量游戏与专属福利。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">游戏分类</Link>
                <Link to="/articles" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">攻略资讯</Link>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/chess" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">棋牌游戏</Link>
                <Link to="/category/esports" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电子竞技</Link>
                <Link to="/category/live" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">真人娱乐</Link>
                <Link to="/category/slot" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电子游艺</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-background-400">客服邮箱：support@2pg.com</p>
                <p className="text-sm text-background-400">服务时间：7×24小时</p>
                <Link to="/about" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer">查看更多联系方式 →</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2026 2pg·com 版权所有 | 保留一切权利</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}